import { render, staticRenderFns } from "./AppTagSelect.vue?vue&type=template&id=14b36d04&"
import script from "./AppTagSelect.vue?vue&type=script&lang=js&"
export * from "./AppTagSelect.vue?vue&type=script&lang=js&"
import style0 from "./AppTagSelect.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports